var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21112 8.64678C8.25539 8.5669 7.32978 8.27352 6.50254 7.78828C5.6753 7.30303 4.96753 6.63829 4.43141 5.84307C3.8953 5.04785 3.54451 4.14244 3.40492 3.1936C3.26533 2.24475 3.34049 1.27668 3.62487 0.36075C3.64166 0.306331 3.64137 0.248074 3.62404 0.193826C3.6067 0.139577 3.57316 0.0919427 3.52794 0.0573373C3.48271 0.022732 3.42796 0.00281807 3.37106 0.000277476C3.31417 -0.00226312 3.25787 0.0126917 3.20973 0.0431278C2.35751 0.534002 1.62971 1.21445 1.08269 2.03177C0.535672 2.84909 0.184117 3.78135 0.0552501 4.75635C-0.0736165 5.73135 0.0236638 6.72294 0.339557 7.65431C0.655451 8.58568 1.18148 9.43184 1.87691 10.1273C2.57234 10.8227 3.4185 11.3487 4.34987 11.6646C5.28124 11.9805 6.27282 12.0778 7.24783 11.9489C8.22283 11.8201 9.15509 11.4685 9.97241 10.9215C10.7897 10.3745 11.4702 9.64667 11.9611 8.79445C11.9896 8.74637 12.0029 8.69082 11.9995 8.63504C11.996 8.57925 11.9758 8.5258 11.9416 8.48163C11.9073 8.43746 11.8606 8.40461 11.8074 8.38736C11.7542 8.37011 11.6971 8.36924 11.6434 8.38488C10.8569 8.62716 10.0312 8.71607 9.21112 8.64678Z",
    fill: "#0D4A74",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.27914224b3a81deaebadc9a6e48b8307.svg";
export { ForwardRef as ReactComponent };